import { render, staticRenderFns } from "./ListInventory.vue?vue&type=template&id=22cc5d9e&scoped=true&"
import script from "./ListInventory.vue?vue&type=script&lang=js&"
export * from "./ListInventory.vue?vue&type=script&lang=js&"
import style0 from "./ListInventory.vue?vue&type=style&index=0&id=22cc5d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc5d9e",
  null
  
)

export default component.exports